<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formClick" :formData="formData"></FORM>
    <table-page ref="childTable" :pageData="pageData"></table-page>
  </div>
</template>

<script>
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import DateUtil from '@/utils/IM/tradeDataUtil.js'
import Qs from 'qs'
import Url from '@/views/merchandiser/util/url'

let typeArr = { 1: '订阅', 2: '取消订阅', 3: '訂閱失敗' }
export default {
  name: 'list',
  components: {
    tablePage,
    FORM
  },
  mounted() {

  },
  methods: {
    /*查询表单按钮点击事件*/
    formClick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)
      }
    },

    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    }

  },
  data() {
    return {
      queryData: {},
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { title: '跟单客户账号', field: 'subscribeCustomerNumber' },
          { title: '信号源账号', field: 'signalCustomerNumber' },
          { title: '開始時間', field: 'startTime', type: 5 },
          { title: '結束時間', field: 'endTime', type: 5 },
          { click: window.$t('common.search') }
        ]
      },
      /*table生成*/
      pageData: {
        isShow: false,
        queryUrl: Url.signal.subscribeList,
        selection: false,
        sequence: true,
        size: 10,
        method: 'get',
        cols: [
          { title: '跟单客户账号', field: 'subscribeCustomerNumber' },
          { title: '跟单客户所属公司', field: 'subscribeCompanyId' },
          { title: '跟单客户所属业务', field: 'subscribeBusinessType' },
          { title: '信号源交易账号', field: 'signalCustomerNumber' },
          { title: '備註', field: 'remark' },
          {
            title: '时间', field: 'createTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '操作', field: 'type', render: (data, full) => {
              return typeArr[data]
            }
          }

        ]
      }
    }
  }
}
</script>
